export const validCombinations = [
	{
		type: "downlink",
		label: "Starlink Downlink Throughput",

		options: {
			"15min": {
				database: "Telemetry_with_avg",
				collection: "downlink15min",
			},
			"3h": {
				database: "Telemetry_with_avg",
				collection: "downlinkfor3h",
			},
			"24h": {
				database: "Telemetry_with_avg",
				collection: "downlinkfor24h",
			},
			"7days": {
				database: "Starlink_Telemetry",
				collection: "Average_Downlink_Throughput",
			},
			"30days": {
				database: "Starlink_Telemetry",
				collection: "Average_Downlink_Throughput_30days",
			},
		},
	},
	{
		type: "uplink",
		label: "Starlink Uplink Throughput",
		options: {
			"15min": {
				database: "Telemetry_Uplink_Avg",
				collection: "Uplink15min",
			},
			"3h": {
				database: "Telemetry_Uplink_Avg",
				collection: "uplink3h",
			},
			"24h": {
				database: "Telemetry_Uplink_Avg",
				collection: "uplink24h",
			},
			"7days": {
				database: "Starlink_Telemetry",
				collection: "Average_Uplink_Throughput",
			},
			"30days": {
				database: "Starlink_Telemetry",
				collection: "Average_Uplink_Throughput_30days",
			},
		},
	},
	{
		type: "pinglatency",
		label: "Starlink Latency",
		options: {
			"15min": {
				database: "Telemetry_ping_latency_avg",
				collection: "pinglatency15min",
			},
			"3h": {
				database: "Telemetry_ping_latency_avg",
				collection: "pinglatency3h",
			},
			"24h": {
				database: "Telemetry_ping_latency_avg",
				collection: "pinglatency24h",
			},
			"7days": {
				database: "Starlink_Telemetry",
				collection: "Average_Ping_Latency_Throughput",
			},
			"30days": {
				database: "Starlink_Telemetry",
				collection: "Average_PingLatencyMsAvg_30days",
			},
		},
	},
	{
		type: "signalobstruction",
		label: "Starlink Signal Quality",
		options: {
			"15min": {
				database: "Telemetry_signal_obstruction_avg",
				collection: "signal15min",
			},
			"3h": {
				database: "Telemetry_signal_obstruction_avg",
				collection: "signal3h",
			},
			"24h": {
				database: "Telemetry_signal_obstruction_avg",
				collection: "signal24h",
			},
			"7days": {
				database: "Starlink_Telemetry",
				collection: "Average_Signal_Throughput",
			},
			"30days": {
				database: "Starlink_Telemetry",
				collection: "Average_SignalQuality_30days",
			},
		},
	},
	{
		type: "pingdrop",
		label: "Starlink Ping Drop Rate",
		options: {
			"15min": {
				database: "Telemetry_ping_drop_avg",
				collection: "pingdrop15min",
			},
			"3h": {
				database: "Telemetry_ping_drop_avg",
				collection: "pingdrop3h",
			},
			"24h": {
				database: "Telemetry_ping_drop_avg",
				collection: "pingdrop24h",
			},
			"7days": {
				database: "Starlink_Telemetry",
				collection: "Average_Ping_Drop_Throughput",
			},
			"30days": {
				database: "Starlink_Telemetry",
				collection: "Average_PingDropRateAvg_30days",
			},
		},
	},
	{
		type: "obstruction",
		label: "Starlink Obstruction",
		options: {
			"15min": {
				database: "Telemetry_obstruction_avg",
				collection: "obstruction15min",
			},
			"3h": {
				database: "Telemetry_obstruction_avg",
				collection: "obstruction3h",
			},
			"24h": {
				database: "Telemetry_obstruction_avg",
				collection: "obstruction24h",
			},
			"7days": {
				database: "Starlink_Telemetry",
				collection: "Average_ObstructionPercentTime_Throughput",
			},
			"30days": {
				database: "Starlink_Telemetry",
				collection: "Average_obstruction_Throughput_30days",
			},
		},
	},
];

/**
 * @typedef {'15m' | '3h' | '24h' | '7d' | '30d'} TimeRange
 */

/**
 * Format a Unix timestamp (in seconds) based on the selected time range.
 *
 * - For short ranges (1h, 3h, 24h) → returns time in "HH:MM" format.
 * - For longer ranges (7d, 30d) → returns date in "MMM DD" format.
 *
 * @param {number} timestamp - Unix timestamp in seconds.
 * @param {TimeRange} range - Selected time range.
 * @returns {string} Formatted date/time string.
 */
export const formatTimestamp = (timestamp, range) => {
	const date = new Date(timestamp * 1000);

	switch (range) {
		case "15m":
		case "3h":
		case "24h":
			// Show time only (HH:MM)
			return date.toLocaleTimeString("en-US", {
				hour: "2-digit",
				minute: "2-digit",
				hour12: false,
			});
		case "7d":
		case "30d":
			// Show date only (MMM DD)
			return date.toLocaleDateString("en-US", {
				month: "short",
				day: "numeric",
			});
		default:
			return date.toLocaleTimeString("en-US", {
				hour: "2-digit",
				minute: "2-digit",
				hour12: false,
			});
	}
};

export const telemetryMapper = {
	downlink: {
		metric: "downlink",
		title: "Starlink Downlink (kb/s, mb/s)",
		label: "Downlink",
		unit: "kb/mb",
	},
	uplink: {
		metric: "uplink",
		title: "Starlink Uplink (kb/s, mb/s)",
		label: "Uplink",
		unit: "kb/mb",
	},
	pinglatency: {
		metric: "ping_latency",
		title: "Starlink Latency (ms)",
		label: "Latency",
		unit: "ms",
		multiplier: 1,
	},
	pingdrop: {
		metric: "ping_drop_rate",
		title: "Starlink Ping Drop Rate (%)",
		label: "Ping Drop Rate",
		unit: "%",
		multiplier: 100,
	},
	signalobstruction: {
		metric: "signal_quality",
		title: "Starlink Signal Quality (%)",
		label: "Signal Quality",
		unit: "%",
		multiplier: 100,
	},
	obstruction: {
		metric: "obstruction_percent_time",
		title: "Obstruction Percent Time (%)",
		label: "Obstruction",
		unit: "%",
		multiplier: 1,
	},
};
